module.exports = __webpack_public_path__ + "static/media/294596.e24ed34a.png";